<template>
  <div
    class="modal"
    :class="value ? 'show' : 'hide'"
    :style="
      value ? 'display:block;background-color:#3333337a;' : 'display:none;'
    "
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-scrollable" role="document">
      <div class="modal-content" style="width:1000px">
        <div class="modal-header">
          <h3 class="" v-html="text"></h3>
          <div class="close" @click="closeModal">
            <icon class="" width="20px" height="20px" name="times"></icon>
          </div>
        </div>
        <div class="modal-body">
          <div class="container2-form-login">
            <div ref="part1" v-show="currentPart == 'part1'">
              <m-form-text
                placeholder="Identifiant"
                label-position="top"
                v-model="co_login"
                name="login"
                autocomplete
              ></m-form-text>
              <m-form-text
                type="password"
                placeholder="Mot de passe"
                label-position="top"
                v-model="co_password"
                autocomplete
                name="password"
              ></m-form-text>
              <div ref="alert" v-if="alert_txt">{{ alert_txt }}</div>
              <div class="d-flex flex-column links mt-3">
                <a class="pointer" @click="currentPart = 'part2'"
                  >Mot de passe oublié</a
                >
              </div>
              <div class="d-flex justify-content-end">
                <button @click="login()" class=" btn btn-primary btn-connexion">
                  Se connecter
                </button>
              </div>
            </div>

            <div ref="part2" v-show="currentPart == 'part2'">
              <m-form-text
                label="Identifiant ou Email"
                label-position="top"
                v-model="co_login"
                name="login"
                autocomplete
              ></m-form-text>
              <div ref="alert" v-if="alert_txt_part2">
                {{ alert_txt_part2 }}
              </div>
              <div class="d-flex flex-row justify-content-end mt-2 flex-wrap">
                <button
                  @click="currentPart = 'part1'"
                  class="btn btn-secondary mb-2"
                >
                  Annuler
                </button>
                <button @click="sendPassword" class="btn btn-info ml-2 mb-2">
                  Changer le mot de passe
                </button>
              </div>
            </div>

            <div ref="part3" v-show="currentPart == 'part3'">
              Vous allez recevoir un mail dans quelques instant, cliquez sur le
              lien pour mettre à jour votre mot de passe.
              <div>
                <!--  <button
                  color="black"
                  @click="currentPart = 'part1'"
                  class="btn btn-primary mt-2"
                >
                  Se connecter maintenant
                </button> -->
              </div>
            </div>

            <div ref="part4" v-show="currentPart == 'part4'">
              <div v-if="!alert_txt_part4">
                <m-form-text
                  type="password"
                  label="Nouveau mot de passe"
                  label-position="top"
                  v-model="co_password1"
                  autocomplete
                  name="password"
                ></m-form-text>
                <m-form-text
                  type="password"
                  label="Retaper votre mot de passe"
                  label-position="top"
                  v-model="co_password2"
                  autocomplete
                  name="password"
                ></m-form-text>
                <div class="d-flex flex-row justify-content-end mt-2">
                  <button
                    color="black"
                    @click="newpassword"
                    class="btn btn-info ml-auto "
                  >
                    Redéfinir le nouveau mot de passe
                  </button>
                </div>
              </div>
              <div ref="alert" v-if="alert_txt_part4">
                {{ alert_txt_part4 }}
              </div>
            </div>

            <div ref="part5" v-show="currentPart == 'part5'">
              C'est bon !
              <br />Votre nouveau mot de passe a été définit. <br />Vous pouvez
              maintenant vous connecter.
              <div>
                <button @click="currentPart = 'part1'" class="btn btn-primary">
                  Se connecter maintenant
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="modal-footer">
          <button class="btn btn-mouveal" @click="deleteWin">Ok</button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
/* export default {
  name: "mconfirmdialog",
  props: ["value", "text", "sousText"],
  data() {
    return {
      dialog: false,
      widthWin: "1000px"
    };
  },
  mounted() {},
  watch: {
    value: function(val) {
      this.dialog = val;
      this.widthWin = this.width ? this.width : "1000px";
    }
  },
  components: {},
  methods: {
    deleteWin() {
      this.dialog = false;
      this.$emit("input", false);
      this.$emit("close");
    }
  }
}; */
</script>
<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "loginmodal",
  components: {},
  props: ["value", "text", "sousText"],
  data() {
    return {
      dialog: false,
      currentPart: "part1",
      societyName: "",
      logoUrl: "",
      co_login: "",
      co_password: "",
      co_password1: "",
      co_password2: "",
      alert_txt: "",
      alert_type: "warning",
      alert_txt_part2: "",
      alert_type_part2: "warning",
      alert_txt_part4: "",
      alert_type_part4: "warning",
      challenge_newpassword: "",
      co_id: "",
      dialogErr: false,
      dialogErrTxt: ""
    };
  },
  mounted() {
    //  this.$root.$children[0].hideMenus();
    //  this.$root.$children[0].resizeMainContainer();
    // this.loadAppData();
    if (this.$route.name == "resetpass") {
      this.currentPart = "part4";
      this.co_password1 = "";
      this.co_password2 = "";
      this.co_id = this.$route.params.co_id;
      /*       this.checkchallenge(
        this.$route.params.co_id,
        this.$route.params.challenge
      ); */
    }
  },
  methods: {
    closeModal() {
      this.$emit("input", false);
    },
    async newpassword() {
      //if (!this.challenge_newpassword) return;
      /*** vérification du mot de passe */
      if (!this.co_password1 || !this.co_password2) {
        this.dialogErrTxt = "Vous devez choisir un mot de passe";
        this.dialogErr = true;
      }
      if (this.co_password1 !== this.co_password2) {
        this.dialogErrTxt = "les mots de passe doivent être identiques";
        this.dialogErr = true;
      }
      if (!this.dialogErr) {
        let response = await this.$axios.post(
          this.$config.server_url +
            "/api/1.0/signin/forgetpassword/newpassword",
          {
            co_password: this.co_password1,
            co_id: this.co_id
          }
        );
        if (response.data.err) {
          this.alert_txt_part4 = "Erreur";
        } else {
          this.currentPart = "part5";
        }
      }
    },
    async checkchallenge(co_id, challenge) {
      this.co_id = co_id;
      let response = await this.$axios.post(
        this.$config.server_url +
          "/api/1.0/signin/forgetpassword/checkchallenge",
        { co_id, challenge }
      );
      if (response.data.err) {
        this.alert_txt_part4 = "Erreur de challenge";
      } else {
        // this.currentPart = "part3";
        this.challenge_newpassword = response.data.data.challenge;
      }
    },
    async sendPassword() {
      let response = await this.$axios.post(
        this.$config.server_url + "/api/1.0/signin/forgetpassword",
        { co_login: this.co_login }
      );
      if (response.data.err) {
        this.alert_txt_part2 =
          "Nous n'avons pas pu retrouver votre identifiant";
      } else {
        this.currentPart = "part3";
      }
    },
    // async loadAppData() {
    //   let response = await this.$axios.get(
    //     this.$config.server_url + "/api/1.0/app-datas",
    //     {}
    //   );
    //   this.societyName = response.data.data.societyName;
    //   this.logoUrl = response.data.data.logoUrl;
    // },
    async login() {
      try {
        let response = await this.$axios.post(
          this.$config.server_url + "/web/1.0/signin",
          { co_login: this.co_login, co_password: this.co_password }
        );
        if (response.data.err) {
          //console.log("response.data.err", response.data.err);
          this.alert_txt = "Erreur de connexion";
          this.alert_type = "warning";
          this.dialogErrTxt =
            "Un problème est survenu. Votre identifiant ou votre mot de passe est incorrect.<br><br>Si vous avez reçu un code d'activation, veillez <a href='#/subscribe'>vous connecter ici </a>";
          this.dialogErr = true;
          /*           this.$store.dispatch(
            "showDialogError",
            "Un problème est survenu. Votre identifiant ou votre mot de passe est incorrect"
          ); */
          return;
        }
        this.alert_txt = "Vous êtes connecté";
        this.alert_type = "success";
        // this.$store.commit("set_token", response.data.accesstoken);
        // this.$store.commit("set_refreshtoken", response.data.refreshtoken);
        // this.$store.commit("set_user", response.data.data);
        this.$store.commit("set_connexion", {
          accesstoken: response.data.accesstoken,
          user: response.data.data
          // offers: response.data.data.rows_ac
        });
        //   this.$root.$children[0].showMenus();
        // this.$router.push("/homeprive");
        this.dialog = false;
        this.$emit("input", false);
      } catch (error) {
        console.error("error", error);
        this.alert_txt = "Erreur!!!";
        this.alert_type = "warning";
      }
    }
  }
};
</script>
<style lang="scss">
.modal-body {
  // padding: 30px 15px 30px 15px;
}
.container2-form-login {
  width: 100%;
  margin: auto;
  padding: 30px;
  background-color: #efefef;
  border-radius: 5px;
}
.links {
  align-items: flex-end;
}
.btn-connexion {
  width: 50%;
}
@media (min-width: 576px) {
  .container2-form-login {
    width: 70%;
  }
}
</style>
